import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";
import type { AvailableSessionPoints } from "../types";
export function useAvailableSessionPoints(options) {
  const $ = _c(5);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== apiFetcher) {
    t0 = async () => {
      const res = await apiFetcher("/api/v1/sessions/available-points");
      return {
        availablePoints: (res?.availablePoints ?? {}) as AvailableSessionPoints
      };
    };
    $[0] = apiFetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = options?.enabled ?? true;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      queryKey: QUERY_KEYS.AVAILABLE_SESSION_POINTS,
      queryFn: t0,
      staleTime: 30000,
      gcTime: 300000,
      enabled: t1,
      refetchOnWindowFocus: false
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useQuery(t2);
}